import type { Color } from "@solvari/common-fe";

function toLegacySize(size: "large" | "small" | null | undefined) {
  return size ? ({ small: "sm", large: "lg" } as const)[size] : ("md" as const);
}

function toModernSize(size: "lg" | "md" | "sm" | null | undefined) {
  return size
    ? ({ sm: "small", md: "medium", lg: "large" } as const)[size]
    : ("medium" as const);
}

function toSeverity(color: Color) {
  return (
    {
      danger: "error",
      warning: "warn",
      primary: "info",
      success: "success",
      accent: "success",
      gray: "secondary",
      purple: "info",
    } as const
  )[color];
}

export { toLegacySize, toModernSize, toSeverity };
